<template>
    <div class="min-h-screen">
        <header class="border-b">
            <div class="flex h-25 items-center px-4">
                <img src="./blackbird.png" alt="Blackbird" class="h-20 w-auto" />
                <div class="flex-1" />
                <button class="md:hidden" @click="drawer = !drawer">
                    <MenuIcon class="h-6 w-6" />
                </button>
                <div class="hidden md:flex items-center gap-4">
                    <RouterLink v-for="item in menuItems" 
                        :key="item.title" 
                        :to="item.to"
                        custom
                        v-slot="{ navigate }">
                        <Button 
                            :variant="route.path === item.to ? 'default' : 'ghost'"
                            @click="navigate">
                            {{ item.title }}
                        </Button>
                    </RouterLink>
                    <Feedback />
                    <ProfileButton v-if="isAuthenticated" />
                    <LoginButton v-else />
                </div>
            </div>
        </header>

        <Sheet v-model:open="drawer">
            <SheetContent side="left">
                <nav class="flex flex-col gap-4">
                    <RouterLink v-for="item in menuItems" 
                        :key="item.title" 
                        :to="item.to"
                        custom
                        v-slot="{ navigate }">
                        <Button 
                            :variant="route.path === item.to ? 'default' : 'ghost'"
                            @click="() => {
                                navigate();
                                drawer = false;
                            }">
                            <template v-if="item.title === 'Home'">
                                <img src="./blackbird.png" alt="Blackbird" class="h-20 w-auto" />
                            </template>
                            <template v-else>
                                {{ item.title }}
                            </template>
                        </Button>
                    </RouterLink>
                    <ProfileButton v-if="isAuthenticated" />
                    <LoginButton v-else />
                </nav>
            </SheetContent>
        </Sheet>

        <div class="min-h-screen flex flex-col antialiased">
            <main class="flex-1 h-full w-full px-4 md:px-6 lg:px-8">
                <Toaster />
                <RouterView />
            </main>
        </div>
        <AdminBar v-if="isAdmin" />
    </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute, RouterLink } from 'vue-router';
import { ref } from 'vue';
import { MenuIcon } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import Sheet from '@/components/ui/sheet/Sheet.vue';
import SheetContent from '@/components/ui/sheet/SheetContent.vue';
import Toaster from '@/components/ui/toast/Toaster.vue';
import ProfileButton from '@/profile/ProfileButton.vue';
import LoginButton from '@/profile/LoginButton.vue';
import Feedback from '@/feedback/Feedback.vue';
import { useColorMode } from '@vueuse/core';
import { useUser } from '@/services/user';
import AdminBar from '@/admin/components/AdminBar.vue';

const drawer = ref(false);

const route = useRoute();

const mode = useColorMode();

const { isAuthenticated, isAdmin } = useUser();

const menuItems = ref([
    {
        title: 'Home',
        to: '/',
    },
    {
        title: 'Programs',
        to: '/programs',
    },
    {
        title: 'Scans',
        to: '/scans',
    },
    {
        title: 'Scan Configs',
        to: '/scan-configs',
    },
]);
</script>